import { Injectable } from '@angular/core';
import { ContractRepositoryScheduleSettingInput, ContractRepositoryScheduleSettingOutput } from './4.2.contract/contract.schedule.setting/contract.repository.schedule.setting';
import { ContractNetworkingScheduleSettingOutput } from './4.2.contract/contract.schedule.setting/contract.networking.schedule.setting';
import { NetworkingScheduleSetting } from './4.5.networking/networking.schedule.setting';
import { ModelScheduleSetting } from './4.3.model/model.schedule.setting';
import { EntityScheduleSetting } from '../5.transversal/5.1.entity/entity.schedule.setting';

@Injectable({
    providedIn: 'root'
})
export class RepositoryScheduleSetting implements 
    ContractRepositoryScheduleSettingInput,
    ContractNetworkingScheduleSettingOutput
{

    constructor(
        private networking: NetworkingScheduleSetting
    ){
        this.networking.networkingOutput = this;
    }

    private _day: number;
    private _month: number;
    private _year: number;
    private _dayOfWeek: number;

    repoSecheduleSettingListOutput?: ContractRepositoryScheduleSettingOutput;

    repoGetSecheduleSettingList(day: number, month: number, year: number, dayOfWeek: number, plan: number): void {
        this._day = day;
        this._month = month;
        this._year = year;
        this._dayOfWeek = dayOfWeek;
        this.networking.getScheduleSettingList(day, month, year, dayOfWeek, plan);
    }

    scheduleSettingListSuccessfulOutput(data: ModelScheduleSetting): void {
        this.repoSecheduleSettingListOutput?.repoSecheduleSettingSuccessfulOutput(
            this.parseData(data)
        );
    }

    scheduleSettingListFailureOutput(): void {
        this.repoSecheduleSettingListOutput?.repoSecheduleSettingFailureOutput();
    }

    private parseData(data: ModelScheduleSetting): EntityScheduleSetting{
        return {
            initHour: data.init_hour,
            initMinute: data.init_minute,
            finalHour: data.final_hour,
            finalMinute: data.final_minute,
            day: this._day,
            month: this._month,
            year: this._year,
            dayOfWeek: this._dayOfWeek
        }
    }
    
}